const modulesTypes = [
  { key: 'basic', name: 'Basic', path: '/dashboard' },
  { key: 'profile', name: 'Mi Perfil', path: '/profile/dashboard' },
  { key: 'dt', name: 'Dt', path: '/dt/welcome' }
];

export default modulesTypes;
